(function () {
  'use strict';

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const value = (parseInt(cents, 10) / 100).toFixed(2);
    return (format || '{{ amount }}').replace(/\{\{\s*amount[^}]*\}\}/, value);
  }

  function debounce(fn, ms) {
    let t;
    return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), ms); };
  }

  const productCache = new Map();

  async function fetchProduct(handle) {
    if (productCache.has(handle)) return productCache.get(handle);
    try {
      const res = await fetch('/products/' + handle + '.js');
      if (!res.ok) throw new Error('404');
      const data = await res.json();
      productCache.set(handle, data);
      return data;
    } catch (err) {
      console.warn('[PD] Could not load product:', handle, err.message);
      return null;
    }
  }

  function prefetchAll(pins) {
    const handles = [...new Set(pins.map(p => p.product_handle).filter(Boolean))];
    handles.forEach((h, i) => setTimeout(() => fetchProduct(h), i * 80));
  }

  // Inject parts list hover styles once
  (function() {
    if (document.getElementById('pd-list-styles')) return;
    const s = document.createElement('style');
    s.id = 'pd-list-styles';
    s.textContent = '.pd-parts-row { transition: background .15s, box-shadow .15s; cursor: pointer; }'
      + '.pd-parts-row:hover { background: #F5F7FF !important; box-shadow: inset 0 0 0 2px #1B6CF9; }'
      + '.pd-parts-row:hover .pd-row-info-icon { opacity: 1 !important; }';
    document.head.appendChild(s);
  })();

  let drawerEl = null;
  let drawerCloseCallback = null;

  function closeDrawer() {
    if (!drawerEl) return;
    drawerEl.remove();
    drawerEl = null;
    document.body.style.overflow = '';
    if (drawerCloseCallback) { drawerCloseCallback(); drawerCloseCallback = null; }
  }

  async function openDrawer(pin, moneyFmt, onClose) {
    closeDrawer();
    drawerCloseCallback = onClose;

    const el = document.createElement('div');
    el.id = 'pd-drawer-live';
    el.style.cssText = 'position:fixed;inset:0;z-index:9999;display:flex;align-items:stretch;justify-content:flex-end;';

    el.innerHTML = '<div id="pd-overlay" style="position:absolute;inset:0;background:rgba(0,0,0,0.45);cursor:pointer;"></div>'
      + '<div id="pd-panel" style="position:relative;width:min(420px,100vw);background:#fff;overflow-y:auto;padding:24px;box-shadow:-4px 0 24px rgba(0,0,0,0.12);display:flex;flex-direction:column;gap:16px;">'
      + '<button id="pd-close" style="position:absolute;top:14px;right:14px;width:32px;height:32px;border-radius:50%;border:1px solid #ddd;background:#fff;font-size:20px;line-height:1;cursor:pointer;z-index:1;">&times;</button>'
      + '<div id="pd-body" style="margin-top:8px;"><p style="color:#888;font-size:14px;">Loading product...</p></div>'
      + '</div>';

    document.body.appendChild(el);
    drawerEl = el;
    document.body.style.overflow = 'hidden';

    $('#pd-overlay', el).addEventListener('click', closeDrawer);
    $('#pd-close', el).addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function esc(e) {
      if (e.key === 'Escape') { closeDrawer(); document.removeEventListener('keydown', esc); }
    });

    const product = await fetchProduct(pin.product_handle);
    const body = $('#pd-body', el);

    if (!product) {
      body.innerHTML = '<p style="color:#c00;font-size:14px;">Could not load product &quot;' + pin.product_handle + '&quot;. Check the handle is correct.</p>';
      return;
    }

    const variant = product.variants[0];
    const price = formatMoney(product.price_min, moneyFmt);
    const imgRaw = product.images && product.images[0] ? product.images[0] : null;
    const imgSrc = imgRaw ? imgRaw.replace(/(\.\w+)(\?|$)/, '_240x240$1$2') : null;
    const sku = variant.sku || '';
    const inStock = product.available;

    let variantHtml = '';
    if (product.variants.length > 1) {
      variantHtml = '<select id="pd-variant-sel" style="width:100%;padding:8px;border:1px solid #ddd;border-radius:6px;font-size:13px;margin-bottom:8px;">';
      product.variants.forEach(function(v) {
        variantHtml += '<option value="' + v.id + '"' + (!v.available ? ' disabled' : '') + '>' + v.title + (!v.available ? ' - Out of stock' : '') + '</option>';
      });
      variantHtml += '</select>';
    }

    const atcBg = inStock ? '#D24600' : '#bbb';
    const atcCursor = inStock ? 'pointer' : 'not-allowed';
    const atcText = inStock ? 'Add to Cart' : 'Out of Stock';
    const stockColor = inStock ? '#097431' : '#c00';
    const stockText = inStock ? 'In stock' : 'Out of stock';

    body.innerHTML =
      '<div style="display:flex;gap:14px;margin-bottom:14px;">'
      + (imgSrc ? '<img src="' + imgSrc + '" style="width:100px;height:100px;object-fit:contain;border:1px solid #eee;border-radius:6px;flex-shrink:0;" onerror="this.style.display=\'none\'">' : '')
      + '<div style="flex:1;min-width:0;">'
      + '<p style="font-size:11px;font-weight:600;color:#1B6CF9;text-transform:uppercase;letter-spacing:.05em;margin:0 0 4px;">Part #' + pin.label + '</p>'
      + '<h3 style="font-size:15px;font-weight:600;margin:0 0 4px;line-height:1.3;">' + product.title + '</h3>'
      + (sku ? '<p style="font-size:11px;color:#888;font-family:monospace;margin:0 0 6px;">SKU: ' + sku + '</p>' : '')
      + '<p style="font-size:18px;font-weight:700;color:#1B1C1F;margin:0 0 4px;">' + price + '</p>'
      + '<p style="font-size:12px;font-weight:500;color:' + stockColor + ';margin:0 0 10px;">' + stockText + '</p>'
      + variantHtml
      + '</div>'
      + '</div>'
      + '<div style="display:flex;align-items:center;gap:10px;margin-top:14px;margin-bottom:16px;">'
      + '<div style="display:flex;border:1px solid #ddd;border-radius:6px;overflow:hidden;flex-shrink:0;">'
      + '<button id="pd-minus" style="width:32px;height:40px;border:none;background:#f7f5f0;font-size:20px;cursor:pointer;">-</button>'
      + '<input id="pd-qty" type="number" value="1" min="1" max="99" style="width:40px;height:40px;border:none;border-left:1px solid #ddd;border-right:1px solid #ddd;text-align:center;font-size:14px;">'
      + '<button id="pd-plus" style="width:32px;height:40px;border:none;background:#f7f5f0;font-size:20px;cursor:pointer;">+</button>'
      + '</div>'
      + '<button id="pd-atc" style="flex:1;height:40px;padding:0 16px;background:' + atcBg + ';color:#fff;border:none;border-radius:6px;font-size:15px;font-weight:700;cursor:' + atcCursor + ';letter-spacing:.01em;"' + (!inStock ? ' disabled' : '') + '>' + atcText + '</button>'
      + '</div>'
      + (product.description ? '<div style="font-size:13px;color:#666;line-height:1.6;border-top:1px solid #eee;padding-top:12px;margin-bottom:4px;">' + product.description + '</div>' : '')
      + '<a href="/products/' + product.handle + '" style="display:block;text-align:center;font-size:13px;color:#888;text-decoration:none;margin-top:8px;">View full product page</a>'
      + '<div id="pd-success" style="display:none;text-align:center;padding:24px 0;">'
      + '<p style="font-size:18px;font-weight:600;color:#1B6CF9;margin:0 0 12px;">Added to cart!</p>'
      + '<a href="/cart" style="display:inline-block;padding:10px 24px;background:#1B6CF9;color:#fff;text-decoration:none;border-radius:6px;font-size:14px;font-weight:600;">View Cart</a>'
      + '<br><button id="pd-continue" style="background:none;border:none;font-size:13px;color:#888;cursor:pointer;margin-top:10px;">Continue shopping</button>'
      + '</div>';

    const varSel = $('#pd-variant-sel', el);
    let currentVariantId = variant.id;
    if (varSel) {
      varSel.addEventListener('change', function() {
        currentVariantId = parseInt(varSel.value, 10);
        const v = product.variants.find(function(x) { return x.id === currentVariantId; });
        if (v) {
          el.querySelector('#pd-atc').textContent = v.available ? 'Add to Cart' : 'Out of Stock';
          el.querySelector('#pd-atc').disabled = !v.available;
        }
      });
    }

    const qtyInput = $('#pd-qty', el);
    $('#pd-minus', el).addEventListener('click', function() { qtyInput.value = Math.max(1, parseInt(qtyInput.value) - 1); });
    $('#pd-plus', el).addEventListener('click', function() { qtyInput.value = Math.min(99, parseInt(qtyInput.value) + 1); });

    const atcBtn = $('#pd-atc', el);
    atcBtn.addEventListener('click', async function() {
      const qty = parseInt(qtyInput.value) || 1;
      atcBtn.textContent = 'Adding...';
      atcBtn.disabled = true;
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: currentVariantId, quantity: qty })
        });
        if (!res.ok) throw new Error('failed');
        const cartRes = await fetch('/cart.js');
        const cartData = await cartRes.json();
        $$('[data-cart-count],[data-cart-items-count]').forEach(function(e) { e.textContent = cartData.item_count; });
        $$('#pd-body > *:not(#pd-success)', el).forEach(function(e) { e.style.display = 'none'; });
        $('#pd-success', el).style.display = 'block';
        $('#pd-continue', el).addEventListener('click', closeDrawer);
      } catch(e) {
        atcBtn.textContent = 'Error - try again';
        atcBtn.disabled = false;
      }
    });
  }

  class PartsDiagram {
    constructor(config) {
      this.sectionId   = config.sectionId;
      this.moneyFmt    = config.moneyFormat;
      this.showSku     = config.showSku !== false;
      this.showPrice   = config.showPrice !== false;
      this.pinColor    = config.pinColor || '#1B6CF9';
      this.pinSize     = parseInt(config.pinSize, 10) || 28;
      this.pins        = [];
      this.partsData   = {};
      this.activePin   = null;
      this.searchQuery = '';
      this._initElements();
      this._loadPins();
    }

    _initElements() {
      const s = this.sectionId;
      this.wrapper    = $(`#parts-diagram-${s}`);
      this.diagramImg = $('#pd-diagram-img',  this.wrapper);
      this.pinsLayer  = $('#pd-pins-layer',   this.wrapper);
      this.partsList  = $('#pd-parts-list',   this.wrapper);
      this.partsCount = $('#pd-parts-count',  this.wrapper);
      this.searchEl   = $('#pd-search',       this.wrapper);
    }

    _loadPins() {
      const dataEl = $(`#pd-pins-data-${this.sectionId}`);
      if (!dataEl) return;
      try {
        this.pins = JSON.parse(dataEl.textContent) || [];
      } catch (e) {
        console.error('[PD] Invalid pins JSON:', e);
        return;
      }
      if (this.diagramImg) {
        const img = this.diagramImg;
        const tryReady = () => {
          // Wait until the image has real dimensions
          if (img.complete && img.naturalWidth > 0) {
            this._onImageReady();
          } else if (img.complete && img.naturalWidth === 0) {
            // Image marked complete but no dimensions yet — poll briefly
            let attempts = 0;
            const poll = setInterval(() => {
              attempts++;
              if (img.naturalWidth > 0 || attempts > 40) {
                clearInterval(poll);
                this._onImageReady();
              }
            }, 50);
          } else {
            img.addEventListener('load', () => this._onImageReady());
          }
        };
        tryReady();
      }
      this._bindSearch();
      prefetchAll(this.pins);
      this._loadPartsData();
    }

    _onImageReady() {
      this._renderPins();
      this._matchPanelHeight();
      const ro = new ResizeObserver(debounce(() => {
        this._renderPins();
        this._matchPanelHeight();
      }, 120));
      ro.observe(this.diagramImg);
    }

    _matchPanelHeight() {
      const wrap  = $('#pd-diagram-wrap', this.wrapper);
      const panel = $('#pd-parts-panel',  this.wrapper);
      if (!wrap || !panel) return;
      const h = wrap.getBoundingClientRect().height;
      if (h > 0) panel.style.height = h + 'px';
    }

    _renderPins() {
      const img = this.diagramImg;
      if (!img) return;
      const layer = this.pinsLayer;
      layer.innerHTML = '';
      const r = img.getBoundingClientRect();
      const parentR = img.parentElement.getBoundingClientRect();

      // Account for object-fit:contain letterboxing
      // The image element may be larger than the rendered image content
      const naturalW = img.naturalWidth  || r.width;
      const naturalH = img.naturalHeight || r.height;
      const scale    = Math.min(r.width / naturalW, r.height / naturalH);
      const rendW    = naturalW * scale;
      const rendH    = naturalH * scale;
      const imgOffX  = (r.left - parentR.left) + (r.width  - rendW) / 2;
      const imgOffY  = (r.top  - parentR.top)  + (r.height - rendH) / 2;

      const half = this.pinSize / 2;
      this.pins.forEach(pin => {
        const x = imgOffX + (pin.x / 100) * rendW;
        const y = imgOffY + (pin.y / 100) * rendH;
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pd-pin' + (this.activePin === pin.id ? ' pd-pin--active' : '');
        btn.setAttribute('data-pin-id', pin.id);
        btn.setAttribute('aria-label', 'Part ' + pin.label);
        btn.style.cssText = 'left:' + (x-half) + 'px;top:' + (y-half) + 'px;width:' + this.pinSize + 'px;height:' + this.pinSize + 'px;--pd-pin-color:' + this.pinColor + ';--pd-pin-size:' + this.pinSize + 'px;';
        btn.textContent = pin.label;
        btn.addEventListener('click', () => this._selectPin(pin.id));
        layer.appendChild(btn);
      });
    }

    async _loadPartsData() {
      const handles = [...new Set(this.pins.map(p => p.product_handle).filter(Boolean))];
      await Promise.all(handles.map(async h => {
        const product = await fetchProduct(h);
        if (product) this.partsData[h] = product;
      }));
      this._renderPartsList(this.pins);

      // Auto-highlight pin from ?pin= URL parameter (set by mobile "Fits these machines" link)
      // Only highlights the pin on the diagram — no scrolling to parts list on mobile
      const urlPin = new URLSearchParams(window.location.search).get('pin');
      if (urlPin) {
        const match = this.pins.find(p => String(p.label) === String(urlPin));
        if (match) {
          this.activePin = match.id;
          this._renderPins();
          this._renderPartsList(this.pins);
        }
      }
    }

    _renderPartsList(pins) {
      const list = this.partsList;
      const query = this.searchQuery.toLowerCase();
      const filtered = pins.filter(pin => {
        if (!query) return true;
        const product = this.partsData[pin.product_handle];
        const name  = (product?.title || '').toLowerCase();
        const sku   = (product?.variants?.[0]?.sku || '').toLowerCase();
        const label = String(pin.label).toLowerCase();
        return name.includes(query) || sku.includes(query) || label.includes(query);
      });
      this.partsCount.textContent = filtered.length + ' of ' + this.pins.length + ' parts';
      if (!filtered.length) {
        list.innerHTML = '<li class="pd-parts-empty">No parts match your search.</li>';
        return;
      }
      list.innerHTML = filtered.map(pin => {
        const product  = this.partsData[pin.product_handle];
        const isActive = this.activePin === pin.id;
        const price    = product ? formatMoney(product.price_min, this.moneyFmt) : '';
        const sku      = product?.variants?.[0]?.sku || '';
        const inStock  = product ? product.available : false;
        const thumbSrc = product?.images?.[0] ? product.images[0].replace(/(\.\w+)(\?|$)/, '_160x160$1$2') : null;
        const thumb    = thumbSrc
          ? '<img src="' + thumbSrc + '" style="width:72px;height:72px;object-fit:contain;border-radius:6px;flex-shrink:0;" onerror="this.style.display=\'none\'">'
          : '<span style="width:72px;height:72px;background:#f0ede8;border-radius:6px;flex-shrink:0;display:inline-block;"></span>';
        const pinColor = this.pinColor;
        return '<li class="pd-parts-row' + (isActive ? ' pd-parts-row--active' : '') + '" data-pin-id="' + pin.id + '" style="display:block;padding:14px 16px;border-bottom:1px solid #eee;background:' + (isActive ? '#f0f7f4' : '#fff') + ';">'
          + '<div style="display:flex;align-items:flex-start;gap:12px;margin-bottom:' + (product ? '12px' : '0') + ';">'
          + '<div style="width:26px;height:26px;border-radius:50%;background:' + pinColor + ';color:#fff;display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:700;flex-shrink:0;margin-top:2px;">' + pin.label + '</div>'
          + thumb
          + '<div style="flex:1;min-width:0;">'
          + (sku ? '<p style="font-size:11px;color:#888;margin:0 0 2px;">' + sku + '</p>' : '')
          + '<p style="font-size:14px;font-weight:600;margin:0 0 4px;line-height:1.3;color:#1a1916;">' + (product ? product.title : pin.product_handle) + '</p>'
          + (this.showPrice && price ? '<p style="font-size:16px;font-weight:700;color:#1B1C1F;margin:0 0 2px;">' + price + '</p>' : '')
          + (product ? '<p style="font-size:11px;font-weight:500;margin:0;color:' + (inStock ? '#097431' : '#c0392b') + ';">' + (inStock ? 'In stock' : 'Out of stock') + '</p>' : '')
          + '</div>'
          + '<div class="pd-row-info-icon" style="flex-shrink:0;opacity:0;transition:opacity .15s;align-self:center;width:22px;height:22px;border-radius:50%;border:1.5px solid #1B6CF9;display:flex;align-items:center;justify-content:center;color:#1B6CF9;font-size:12px;font-weight:700;">i</div>'
          + '</div>'
          + (product ? (
            '<div style="display:flex;align-items:center;gap:10px;">'
            + '<div style="display:flex;align-items:center;border:1.5px solid #ddd;border-radius:4px;overflow:hidden;flex-shrink:0;">'
            + '<button class="pd-list-minus" data-pin="' + pin.id + '" style="width:36px;height:36px;border:none;background:#fff;font-size:20px;cursor:pointer;color:#555;">-</button>'
            + '<span class="pd-list-qty" data-pin="' + pin.id + '" style="min-width:28px;text-align:center;font-size:14px;font-weight:600;color:#1B1C1F;user-select:none;">1</span>'
            + '<button class="pd-list-plus" data-pin="' + pin.id + '" style="width:36px;height:36px;border:none;background:#fff;font-size:20px;cursor:pointer;color:#555;">+</button>'
            + '</div>'
            + '<button class="pd-list-atc" data-pin="' + pin.id + '" data-variant="' + (product.variants[0]?.id || '') + '" style="flex:1;height:36px;border:none;border-radius:4px;background:' + (inStock ? '#D24600' : '#bbb') + ';color:#fff;font-size:14px;font-weight:700;cursor:' + (inStock ? 'pointer' : 'not-allowed') + ';letter-spacing:.01em;"' + (!inStock ? ' disabled' : '') + '>'
            + (inStock ? 'Add to Cart' : 'Out of Stock')
            + '</button>'
            + '</div>'
          ) : '')
          + '</li>';
      }).join('');

      // Qty steppers
      $$('.pd-list-minus', list).forEach(btn => {
        btn.addEventListener('click', e => {
          e.stopPropagation();
          const qtyEl = list.querySelector('.pd-list-qty[data-pin="' + btn.dataset.pin + '"]');
          qtyEl.textContent = Math.max(1, parseInt(qtyEl.textContent) - 1);
        });
      });
      $$('.pd-list-plus', list).forEach(btn => {
        btn.addEventListener('click', e => {
          e.stopPropagation();
          const qtyEl = list.querySelector('.pd-list-qty[data-pin="' + btn.dataset.pin + '"]');
          qtyEl.textContent = Math.min(99, parseInt(qtyEl.textContent) + 1);
        });
      });

      // Add to cart from list
      $$('.pd-list-atc', list).forEach(btn => {
        btn.addEventListener('click', async e => {
          e.stopPropagation();
          const qtyEl = list.querySelector('.pd-list-qty[data-pin="' + btn.dataset.pin + '"]');
          const qty = parseInt(qtyEl.textContent) || 1;
          const variantId = parseInt(btn.dataset.variant);
          const orig = btn.textContent;
          btn.textContent = 'Adding...';
          btn.disabled = true;
          try {
            const res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: variantId, quantity: qty })
            });
            if (!res.ok) throw new Error('failed');
            const cartRes = await fetch('/cart.js');
            const cartData = await cartRes.json();
            $$('[data-cart-count],[data-cart-items-count]').forEach(el => el.textContent = cartData.item_count);
            btn.textContent = 'Added!';
            btn.style.background = '#A83800';
            setTimeout(() => {
              btn.textContent = orig;
              btn.style.background = this.pinColor;
              btn.disabled = false;
            }, 2000);
          } catch(err) {
            btn.textContent = 'Error';
            btn.disabled = false;
            setTimeout(() => { btn.textContent = orig; }, 2000);
          }
        });
      });

      // Row click opens drawer (but not when clicking atc/qty buttons)
      $$('.pd-parts-row', list).forEach(row => {
        row.addEventListener('click', e => {
          if (e.target.closest('.pd-list-atc, .pd-list-minus, .pd-list-plus')) return;
          this._selectPin(parseInt(row.dataset.pinId, 10));
        });
      });
    }

    _selectPin(id) {
      this.activePin = this.activePin === id ? null : id;
      this._renderPins();
      this._renderPartsList(this.pins);
      if (this.activePin !== null) {
        const pin = this.pins.find(p => p.id === id);
        if (pin) {
          openDrawer(pin, this.moneyFmt, () => {
            this.activePin = null;
            this._renderPins();
            this._renderPartsList(this.pins);
          });
        }
        setTimeout(() => {
          const row = this.partsList.querySelector('.pd-parts-row[data-pin-id="' + id + '"]');
          if (row) row.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }, 50);
      } else {
        closeDrawer();
      }
    }

    _bindSearch() {
      if (!this.searchEl) return;
      this.searchEl.addEventListener('input', debounce(e => {
        this.searchQuery = e.target.value;
        this._renderPartsList(this.pins);
      }, 200));
    }
  }

  const initialised = new Set();

  function init() {
    const configs = window.PD_CONFIG || {};
    Object.values(configs).forEach(config => {
      if (initialised.has(config.sectionId)) return;
      try {
        new PartsDiagram(config);
        initialised.add(config.sectionId);
      } catch (e) { console.error('[PD] Init error:', e); }
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Also watch for PD_CONFIG being set after the script runs
  // (happens when the section script tag fires after this file)
  const _origDefineProperty = Object.defineProperty;
  window.__pdInit = init;
  document.addEventListener('DOMContentLoaded', () => {
    // Retry a few times in case inline section script fires late
    setTimeout(init, 0);
    setTimeout(init, 100);
    setTimeout(init, 500);
  });

})();